import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { DocumentsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { WorkflowOwner } from 'modules/tasks/hooks/useMaterializedTaskItem'

import DocumentFile from './DocumentFile'

interface Props {
  task: TaskDetail
  owner: WorkflowOwner | undefined
}

const DocumentSignatures = ({ task, owner }: Props) => {
  const taskDetail = task

  const documentIds = (
    taskDetail.signatureDocumentsTypeData?.documentIds || [
      taskDetail.sendDocumentTemplateTypeData?.documentId,
    ]
  ).filter((id): id is string => id !== undefined)

  const { data: documentsData, loading } = useQuery(DocumentsDocument, {
    variables: {
      ids: documentIds,
      sort: 'created_at-desc',
    },
  })

  const documents = documentsData?.documents.documents

  const affectee = task.affectees[0]

  const getOwnerFullName = () => {
    if (!owner) return undefined
    return getFullDisplayName({
      firstName: owner.firstName,
      lastName: owner.lastName,
      canSharePreferredName: owner.employee?.canSharePreferredName ?? false,
      preferredName: owner.employee?.preferredName,
    })
  }

  const employeeName = affectee?.id !== owner?.id ? affectee?.fullName : getOwnerFullName()

  if (loading) return null

  return (
    <Box gap="s16">
      <Text.Header2 color="grey800">{i18n.t('tasks.types.sign_document.title')}</Text.Header2>
      <Box gap="s16">
        {documents?.length ? (
          documents?.map((document) => (
            <DocumentFile document={document} key={document.id} documents={documents} />
          ))
        ) : (
          <Alert color="warning">
            <Box flexDirection="row" gap="s8">
              <Box flexNoShrink>
                <Icon.Medium icon="alert-circle" color="grey800" />
              </Box>

              <Box>
                <Text.Normal weight="medium">
                  {i18n.t('tasks.not_permission.first', {
                    employee_name: employeeName,
                  })}
                </Text.Normal>

                <Text.Normal weight="medium">{i18n.t('tasks.not_permission.second')}</Text.Normal>
              </Box>
            </Box>
          </Alert>
        )}
      </Box>
    </Box>
  )
}

export default DocumentSignatures
